import { Alerta, Button, Card, Row, Stack, TextField } from "@/components";
import type { Reporte } from "@/lib/reportes";
import { useReportesTab } from "./useReportesTab";

export function ReportesTab() {
  const t = useReportesTab();

  return (
    <Stack espacio={6}>
      <h1 className="text-pantalla font-light tracking-[-0.03em]">Reportes</h1>

      <Row envolver espacio={3} alinear="fin">
        <TextField etiqueta="Desde" type="date" value={t.periodo.desde} onChange={(e) => t.cambiarPeriodo("desde", e.target.value)} />
        <TextField etiqueta="Hasta" type="date" value={t.periodo.hasta} onChange={(e) => t.cambiarPeriodo("hasta", e.target.value)} />
      </Row>

      <div className="grid gap-3 sm:grid-cols-2">
        {t.reportes.map((r: Reporte) => (
          <Card key={r.id}>
            <Stack espacio={3}>
              <div>
                <h2 className="text-titulo font-light tracking-tight">{r.titulo}</h2>
                <p className="text-chico text-texto-suave">{r.descripcion}</p>
              </div>
              <Row justificar="fin">
                <Button aria-label={`Descargar: ${r.titulo}`} cargando={t.cargando(r.id)} onClick={() => void t.descargar(r)}>
                  Descargar
                </Button>
              </Row>
              <Alerta texto={t.error(r.id)} />
            </Stack>
          </Card>
        ))}
      </div>
    </Stack>
  );
}
